// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88677bc3","455":"3a38596f","977":"3a563d90"}[chunkId] + ".chunk.js";
};